/*
 * Created on Tue Jul 09 2019
 *
 * Copyright (c) 2019 Laboratori Guglielmo Marconi
 */
import { Injectable, Component }                            from '@angular/core';
import { MatSnackBar , MatSnackBarConfig }                  from "@angular/material/snack-bar";
import { MatDialog }                                        from "@angular/material/dialog";
import { ConfirmDialog }                                    from '../_components/ConfirmDialog';
import { YesNotDialog }                                     from '../_components/YesNotDialog';
import { BaseDialog }                                       from '../_components/BaseDialog';
import { ErrorDialog }                                      from '../_components/ErrorDialog';
import { TranslateService }                                 from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class InterfaceService {
  constructor(
      private _snackBar       : MatSnackBar,
      private _confirmDialog  : MatDialog,
      private _dialog         : MatDialog,
      private _translateService : TranslateService
      ) { 
  }

  private snackbarConfig: MatSnackBarConfig = {};
  
  public openReturnSnackBar(data) : void
  {
    var message = this._translateService.instant(data["retdata"]["data"]);
    this.openSimpleInfoSnackBar(message);
  }

  public openSimpleInfoSnackBar(message : string, autohide = true) : void
  {
    this.snackbarConfig["panelClass"] = "snackbar-success";
    this._snackBarOpen(message, autohide);
  }

  public openSimpleWarningSnackBar(message : string, autohide = false) : void
  {
    this.snackbarConfig["panelClass"] = "snackbar-warning";
    this._snackBarOpen(message, autohide);
  }

  public openSimpleErrorSnackBar(message : string, autohide = false) : void
  {
    this.snackbarConfig["panelClass"] = "snackbar-error";
    this._snackBarOpen(message, autohide);
  }
  
  public openSmallErrorDialogialog(data , dialog_options = {}) : void
  {
    if (dialog_options["minWidth"] === undefined)
    {
      dialog_options["minWidth"]                = "700px";
    }
    if (dialog_options["minHeight"] === undefined)
    {
      dialog_options["minHeight"]               = "500px";  
    }
    dialog_options["data"]                    = data;
    this.openCustomDialog(ErrorDialog , dialog_options);
  }

  public openGenericServerErrorDialog()
  {
    var dialog_options = {};
    dialog_options["minWidth"]                = "500px";
    dialog_options["minHeight"]               = "200px";  
    dialog_options["data"]                    = {};
    dialog_options["data"]["message"]         = "generic.generic_error";
    dialog_options["data"]["detailedMessage"] = "generic.generic_server_error";
    this.openCustomDialog(ErrorDialog , dialog_options);
  }
  
  public openSmallErrorDialog(data) : void
  {
      var dialog_options = {};
      dialog_options["minWidth"]                = "500px";
      dialog_options["minHeight"]               = "200px";  
      dialog_options["data"]                    = data;
      this.openCustomDialog(ErrorDialog , dialog_options);
  }

  private _snackBarOpen(message, autohide = true)
  {
    if (autohide)
    {
      this.snackbarConfig["duration"] = 3000;
    }
    if (message.length > 150)
    {
      message = message.substring(0,150);
    }
    this._snackBar.open(message,'close', this.snackbarConfig);
  }

  public openCustomSnackBar(inner_component , snackbar_options = {})
  {
    this._snackBar.openFromComponent(inner_component, snackbar_options);
  }

  //***************************** */

  openConfirmDialog( confirmFunction , custom_message = null ) {
    if (custom_message === null)
    {
      custom_message = this._translateService.instant("generic.confirm_note");
    }
    const dialogRef = this._confirmDialog.open(ConfirmDialog, { data: { "custom_message" : custom_message } } );

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //fai cose
        confirmFunction();
      }
    });
  }


  openTextCustomDialog(data, callbackConfirmDialog = null)
  {
    const dialogRef = this._confirmDialog.open(BaseDialog ,{ data : data } );

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (callbackConfirmDialog) 
      {
        callbackConfirmDialog();
      }
    });
  }


  public openCustomDialog(inner_component , dialog_options = {} , close_callback : Function = null)
  {
    const dialogRef = this._dialog.open(inner_component, dialog_options);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (close_callback !== null)
        {
          close_callback();
        }
    });
  }

  openYesNoDialog( yesFunction , noFunction , custom_message = null ) {
    if (custom_message === null)
    {
      custom_message = this._translateService.instant("generic.select_answer");
    }
    const dialogRef = this._confirmDialog.open(YesNotDialog, { data: { "custom_message" : custom_message } } );

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed !== null && confirmed !== undefined)
      {
        if (confirmed) {
          yesFunction();
        }
        else
        {
          noFunction();
        }
      }
      
    });
  }
  

  
}

